module.exports = __webpack_public_path__ + "img/about-us.68c4c7d8.svg";